import { render, staticRenderFns } from "./ExportLeads.vue?vue&type=template&id=6c6336e7&"
import script from "./ExportLeads.vue?vue&type=script&lang=js&"
export * from "./ExportLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports